import React, {useEffect, useState} from 'react';
import cx from 'classnames';
import {SelectInput} from '../../components/crousal/SelectInput';

interface IProps {
    onChange: (page: number) => void;
    totalPages: number;
}

export function Pagination({onChange, totalPages}: IProps) {
    const [currentPage, setCurrentPage] = useState(1);
    const [arrowButtonClicked, setArrowButtonClicked] = useState(true);
    const pageNumbers = [];

    if (currentPage > totalPages && totalPages !== 0) {
        setCurrentPage(1)
    }

    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push({
            'value': i,
            'label': i.toString()
        });
    }

    function arrowLeft() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
        }

        setArrowButtonClicked(false);
    }

    function arrowRight() {
        if (currentPage !== totalPages) {
            setCurrentPage(currentPage + 1);
        }

        setArrowButtonClicked(true);
    }

    useEffect(() => {
        onChange(currentPage)
    }, [currentPage]);

    return (
        <div className="mt-4 flex justify-center items-center text-center p-2 bg-mid-black">
            <div className="text-left ml-2 text-40 text-xs">
                page {totalPages > 0 ? currentPage : 0} of {totalPages}
            </div>
            <div className="flex-1"/>
            {totalPages !== 0 ?
                <div className="flex justify-center items-center text-center">
                    <div className="text-40 text-xs">The page you are on</div>
                    <div className="mr-2">
                        <SelectInput
                            value={currentPage}
                            onChange={setCurrentPage}
                            options={pageNumbers}
                            className={"w-10 ml-2"}
                            isSkinsAndChampionsSelectBox={true}
                            disabled={totalPages === 0}
                        />
                    </div>
                    <div
                        className={cx(
                            "flex cursor-pointer w-5 h-5 justify-center items-center text-center rounded text-sm",
                            arrowButtonClicked ? 'bg-metallic-grey' : 'bg-smurfs-gold text-almost-black-light'
                        )}
                        onClick={arrowLeft}
                    >
                        <i className="fas fa-caret-left"/>
                    </div>

                    <div
                        className={cx(
                            "flex w-5 cursor-pointer ml-1 h-5 justify-center items-center text-center rounded text-sm",
                            arrowButtonClicked ? 'bg-smurfs-gold text-almost-black-light' : 'bg-metallic-grey'
                        )}
                        onClick={arrowRight}
                    >
                        <i className="fas fa-caret-right"/>
                    </div>
                </div>
                : null}
        </div>
    );
}
